import _sfc_main from './src/color-picker.vue2.mjs';
export { colorPickerEmits, colorPickerProps, colorPickerPropsDefaults } from './src/color-picker.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElColorPicker = withInstall(_sfc_main);

export { ElColorPicker, ElColorPicker as default };
//# sourceMappingURL=index.mjs.map
